var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 7.49984C2.32955 7.49984 2.96543 7.76323 3.43427 8.23207C3.90311 8.70091 4.1665 9.3368 4.1665 9.99984C4.1665 10.6629 3.90311 11.2988 3.43427 11.7676C2.96543 12.2364 2.32955 12.4998 1.6665 12.4998V14.1665C1.6665 14.6085 1.8421 15.0325 2.15466 15.345C2.46722 15.6576 2.89114 15.8332 3.33317 15.8332H16.6665C17.1085 15.8332 17.5325 15.6576 17.845 15.345C18.1576 15.0325 18.3332 14.6085 18.3332 14.1665V12.4998C17.6701 12.4998 17.0342 12.2364 16.5654 11.7676C16.0966 11.2988 15.8332 10.6629 15.8332 9.99984C15.8332 9.3368 16.0966 8.70091 16.5654 8.23207C17.0342 7.76323 17.6701 7.49984 18.3332 7.49984V5.83317C18.3332 5.39114 18.1576 4.96722 17.845 4.65466C17.5325 4.3421 17.1085 4.1665 16.6665 4.1665H3.33317C2.89114 4.1665 2.46722 4.3421 2.15466 4.65466C1.8421 4.96722 1.6665 5.39114 1.6665 5.83317V7.49984Z",
    stroke: "#FBD050",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 4.1665V5.83317",
    stroke: "#FBD050",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 14.1665V15.8332",
    stroke: "#FBD050",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 9.1665V10.8332",
    stroke: "#FBD050",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketicon);
export default __webpack_public_path__ + "static/media/ticket icon.2b49768da05166bcd06ed5041a2af3e4.svg";
export { ForwardRef as ReactComponent };